"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculationSchema = exports.createCalculationBodySchema = void 0;
// Wire shapes of Screen 8's `Calculate` action (SPEC §8 Screen 8, §9 `POST /api/calculate`; D-1067; J-041),
// served at `POST /api/v1/calculations` (D-973). The response is the run's summary: counts and each
// group's totals, raw numbers (SPEC §9), never a patient field.
const zod_1 = require("zod");
exports.createCalculationBodySchema = zod_1.z.object({
    /** Required, as `pnpm calculate --year` is (D-1067): a default year would recalculate the wrong one silently. */
    year: zod_1.z.number().int().min(2000).max(2100),
});
const count = zod_1.z.number().int().min(0);
/** A group's quality total and Score Est. as the run computed them (SPEC §6.4, CR-001 §5.11). */
const calculationGroupSchema = zod_1.z.object({
    groupId: zod_1.z.number().int(),
    measuresScored: count,
    qualityEarned: zod_1.z.number(),
    qualityMax: zod_1.z.number(),
    scoreEst: zod_1.z.number().nullable(),
});
exports.calculationSchema = zod_1.z
    .object({
    performanceYear: zod_1.z.number().int(),
    /**
     * The run rebuilds every ACO's groups; the counts and `totals` cover only the caller's ACOs'
     * groups, so a caller limited to one ACO learns nothing of another (SPEC §11; J-130, D-1093).
     * The year's performance groups in the caller's ACOs.
     */
    groups: count,
    /** `core.group_patient_measure` rows written for those groups. */
    patientMeasures: count,
    /** `core.group_measure_score` rows written for those groups. */
    measureScores: count,
    totals: zod_1.z.array(calculationGroupSchema),
})
    .meta({ id: "AcoCalculation" });
//# sourceMappingURL=calculations.js.map